import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Alert } from 'src/shared/components/alert';
import { List } from 'src/shared/components/list';
import { ClassItem } from './classItem';
import { SelectAll } from './selectAll';
export function SelectionList({ classes }) {
    const { t } = useTranslation();
    return (_jsx("div", { children: _jsxs(List, { children: [_jsx(SelectAll, { classes: classes }), classes.map((classItem) => (_jsx(ClassItem, { classItem: classItem }, classItem.hashId))), _jsx(Alert, { className: "mx-5 mb-5 mt-2 text-small", children: t('modules.form.classes.info') })] }) }));
}
